// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_content_logo-module__wrapper--2MdkV{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "header_content_logo-module__wrapper--2MdkV"
};
module.exports = exports;
